import Immutable from "immutable";
import moment from "moment";

import {
  FETCH_STREAM_LIST,
  FETCH_STREAM_LIST_SUCCESS,
  FETCH_STREAM_LIST_ERROR,
  USER_SIGNED_OUT,
} from "../constants/action-types";

const stream = Immutable.Record({
  id: undefined,
  name: undefined,
  type: undefined,
  product_type: undefined,
  adjustment_factor_ids: undefined,
  sample_point_ids: undefined,
  restrict_to_site_ids: undefined,
  metadata: undefined,
  transport_type: undefined,
  source_facility: undefined,
  terminal_facility: undefined,
  associated_with_tank: undefined,
});

// @ts-expect-error legacy opshub typing
export const data = new Immutable.Set([]);

export const StreamState = Immutable.Record(
  {
    isRequestInProgress: false,
    fetchError: false,
    fetchErrorMessage: "",
    fetchErrorStatus: "",
    lastRetrievedTime: 0,
    data: data,
  },
  "StreamState"
);

export default (state = new StreamState(), action) => {
  let newData = [];
  switch (action.type) {
    case FETCH_STREAM_LIST:
      return state.withMutations((s) => {
        // @ts-expect-error legacy opshub typing
        s.isRequestInProgress = true;
        // @ts-expect-error legacy opshub typing
        s.fetchError = false;
        // @ts-expect-error legacy opshub typing
        s.fetchErrorMessage = "";
        // @ts-expect-error legacy opshub typing
        s.fetchErrorStatus = "";
      });

    case FETCH_STREAM_LIST_SUCCESS:
      // @ts-expect-error legacy opshub typing
      newData = new Immutable.Set(
        action.payload.map((streamData) => new stream(streamData))
      ).sort((a, b) => a.name.localeCompare(b.name));

      return state.withMutations((s) => {
        // @ts-expect-error legacy opshub typing
        s.isRequestInProgress = false;
        // @ts-expect-error legacy opshub typing
        s.data = newData;
        // @ts-expect-error legacy opshub typing
        s.lastRetrievedTime = moment().unix();
      });

    case FETCH_STREAM_LIST_ERROR:
      return state.withMutations((s) => {
        // @ts-expect-error legacy opshub typing
        s.isRequestInProgress = false;
        // @ts-expect-error legacy opshub typing
        s.fetchError = true;
        // @ts-expect-error legacy opshub typing
        s.fetchErrorMessage = action.payload.message;
        // @ts-expect-error legacy opshub typing
        s.fetchErrorStatus = action.payload.status;
      });

    case USER_SIGNED_OUT:
      return state.withMutations((s) => {
        // @ts-expect-error legacy opshub typing
        s.data = new Immutable.Set([]);
        // @ts-expect-error legacy opshub typing
        s.isRequestInProgress = false;
        // @ts-expect-error legacy opshub typing
        s.fetchError = false;
        // @ts-expect-error legacy opshub typing
        s.fetchErrorMessage = "";
        // @ts-expect-error legacy opshub typing
        s.fetchErrorStatus = "";
        // @ts-expect-error legacy opshub typing
        s.lastRetrievedTime = 0;
      });

    default:
      return state;
  }
};
